import Vue from 'vue'
import 'core-js/stable'
import App from './App'
import VueHead from 'vue-head'
import router from './router'
import VueCarousel from 'vue-carousel'
import VuejsDialog from 'vuejs-dialog'
import VueAxios from 'vue-axios'
import axios from 'axios'
import SimpleVueValidation from 'simple-vue-validator'
import store from './store'
import Vuex from 'vuex'
import Storage from 'vue-ls'
import Toasted from 'vue-toasted'
import LazyLoadDirective from '@/assets/js/imgLazyLoadObserver'
import LazyLoadBannerImpressionDirective from '@/assets/js/bannerImpressionTrack'
import ResizeObserver from 'resize-observer-polyfill'
import Intersect from './directives/intersect'
import device from 'vue-device-detector-js'
const script = document.createElement('script')
script.src = 'https://cdn.rum-ingress-coralogix.com/coralogix/browser/latest/coralogix-browser-sdk.js'
script.onload = () => {
  window.CoralogixRum.init({
    application: 'thesouledstore-frontend',
    environment: 'production',
    public_key: process.env.CORALOGIX_PUBLIC_KEY,
    coralogixDomain: 'AP1',
    version: 'v1.0.2',
    traceParentInHeader: {
      enabled: true
    }
  })
}
document.head.appendChild(script)
Vue.use(Toasted)
var options = {
  namespace: 'tss-v2__',
  name: 'ls',
  storage: 'local'
}
// custom directive for lazyload of viewport only images
Vue.directive('lazyloadImage', LazyLoadDirective)

// custom directive for lazyload & measure banner impression on view images
Vue.directive('bannerImageLoad', LazyLoadBannerImpressionDirective)

// custom directive for first content paint of image
Vue.directive('imageBackground', {
  inserted (el, binding, vnode) {
    if (binding.value && binding.value.length && el && el.parentElement && !el.parentElement.style.height) {
      let resolution = binding.value && binding.value.split(':')
      const ratio = resolution[0] / resolution[1]
      let renderWidth = el.parentElement.getBoundingClientRect().width
      if (renderWidth) {
        let renderHeight = parseInt(renderWidth / ratio)
        el.parentElement.style.height = renderHeight + 'px'
        el.parentElement.style.background = '#FFEBE7'
      }
    }
  },
  componentUpdated (el, binding, vnode) {
    if (binding.value && binding.value.length && el && el.parentElement && !el.parentElement.style.height) {
      let resolution = binding.value && binding.value.split(':')
      const ratio = resolution[0] / resolution[1]
      let renderWidth = el.parentElement.getBoundingClientRect().width
      if (renderWidth) {
        let renderHeight = parseInt(renderWidth / ratio)
        el.parentElement.style.height = renderHeight + 'px'
        el.parentElement.style.background = '#FFEBE7'
      }
    }
  }
})

// custom directive to detect outside click of an element
Vue.directive('click-outside', {
  bind (el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

Vue.directive('dynamicMinHeight', {
  inserted (el) {
    let timeoutId = null
    const observer = new ResizeObserver(entries => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        for (let entry of entries) {
          if (entry.target === el) {
            el.style.minHeight = `${entry.contentRect.height}px`
          }
        }
      }, 100)
    })
    observer.observe(el)
    if (router.currentRoute.path === '/') {
      el.style.minHeight = '0px'
    }
    // Vue Router navigation guard
    const unbindRouteChange = router.beforeEach((to, from, next) => {
      setTimeout(() => {
        observer.disconnect()
        el.style.minHeight = '0px'
        observer.observe(el)
      }, 0)
      next()
    })
    el._unbindRouteChange = unbindRouteChange
  },
  unbind (el) {
    // Clean up the navigation guard when the directive is unbound
    if (el._unbindRouteChange) {
      el._unbindRouteChange()
      delete el._unbindRouteChange
    }
  }
})

Vue.directive('intersect', Intersect)

Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'fw-storyblock',
  'fw-embed-feed'
]
Vue.prototype.$http = axios
Vue.prototype.$hostname = process.env.V1_HOST
// Polyfills are now loaded via core-js/stable import
// No need for Vue.use(babelPolyfill)
Vue.use(VueHead, {
  separator: ''
})
Vue.use(VueCarousel)
Vue.use(VuejsDialog)
Vue.use(Storage, options)
import 'es6-promise/auto'
/* eslint-disable no-new */

Vue.use(VueAxios, axios)
Vue.use(SimpleVueValidation, {mode: 'conservative'})
Vue.use(Vuex)

// Generate random mac address
if (!Vue.ls.get('tss_mac_token')) {
  var navigatorInfo = window.navigator
  var screenInfo = window.screen
  var uid = navigatorInfo.mimeTypes.length
  uid += navigatorInfo.userAgent.replace(/\D+/g, '')
  uid += navigatorInfo.plugins.length
  uid += screenInfo.height || ''
  uid += screenInfo.width || ''
  uid += screenInfo.pixelDepth || ''
  var mactoken = uid + new Date().getTime() + Math.random().toString()
  Vue.ls.set('tss_mac_token', mactoken)
}

// Bot detection function
function isBot () {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return true // SSR or no user agent
  }
  const botPattern = /bot|crawler|spider|crawling|google|bing|msn|duckduckgo|teoma|slurp|yandex|baidu|facebook|twitter|linkedin|whatsapp|telegram/i
  return botPattern.test(navigator.userAgent)
}

//Conditional device detection
if (!isBot()) {
  // Real user - use device detection
  Vue.use(device)
} else {
  // Bot - provide mock $device to prevent undefined errors
  Vue.prototype.$device = {
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    model: null,
    brand: null,
    type: 'desktop',
    os_name: null,
    os_platform: null,
    os_version: null,
    browser_name: null,
    browser_version: null,
    browser_engine: null,
    browser_engine_version: null,
    browser: {
      chrome: false,
      chrome_view: false,
      chrome_mobile: false,
      chrome_mobile_ios: false,
      safari: false,
      safari_mobile: false,
      msedge: false,
      msie_mobile: false,
      msie: false
    },
    os: {
      android: false,
      blackberry: false,
      ios: false,
      windows: false,
      windows_phone: false,
      mac: false,
      linux: false,
      chrome: false,
      firefox: false,
      gamingConsole: false
    },
    isAndroid: false,
    isBlackberry: false,
    isIOS: false,
    isWindows: false,
    isWindowsPhone: false,
    isOsx: false,
    isLinux: false,
    isChromeOs: false,
    isFireFoxOS: false,
    GamingConsole: false,
    isBot: true,
    machine: {
      brand: null,
      model: null,
      os_name: null,
      os_version: null,
      type: 'desktop'
    },
    bot: true,
    client: {},
    device: {}
  }
}

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store,
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js